import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import { useState } from 'react';

export default function HotGossipGrid() {
  const [activeCategory, setActiveCategory] = useState<string>('all');
  const filteredArticles = activeCategory === 'all'
    ? articles
    : articles.filter(a => a.category === activeCategory);

  return (
    <section className="bg-background-50 py-14 md:py-20 px-4 md:px-6">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10">
          <div>
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight">
              全网热门爆料
            </h2>
            <p className="mt-2 text-sm text-foreground-600 max-w-md">
              实时追踪最新爆料动态，深度挖掘网红黑料与娱乐圈反转事件
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => setActiveCategory('all')}
              className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer ${
                activeCategory === 'all'
                  ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              全部
            </button>
            {categories.slice(0, 4).map((cat) => (
              <button
                key={cat.slug}
                onClick={() => setActiveCategory(cat.slug)}
                className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer ${
                  activeCategory === cat.slug
                    ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {filteredArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className={`group rounded-xl overflow-hidden cursor-pointer flex flex-col transition-colors ${
                index === 0 ? 'lg:col-span-1 bg-foreground-900' : 'bg-background-100'
              }`}
            >
              <div className="relative h-52 md:h-60 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-accent-500/90 text-white text-xs font-medium">
                    <i className="ri-price-tag-3-line text-[10px]"></i>
                    {categories.find(c => c.slug === article.category)?.name || article.category}
                  </span>
                  {article.isHot && (
                    <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-primary-500/90 text-white text-xs font-medium">
                      <i className="ri-fire-line text-[10px]"></i>
                      热
                    </span>
                  )}
                </div>
                {article.isVideo && (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                      <i className="ri-play-fill text-white text-xl ml-0.5"></i>
                    </div>
                  </div>
                )}
              </div>
              <div className={`flex-1 p-4 md:p-5 flex flex-col ${index === 0 ? 'bg-foreground-900' : ''}`}>
                <h3 className={`text-base md:text-lg font-bold font-heading leading-snug mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors ${
                  index === 0 ? 'text-white' : 'text-foreground-900'
                }`}>
                  {article.title}
                </h3>
                <p className={`text-sm line-clamp-2 mb-4 ${
                  index === 0 ? 'text-foreground-400' : 'text-foreground-600'
                }`}>
                  {article.excerpt}
                </p>
                <div className={`mt-auto flex items-center justify-between text-xs ${
                  index === 0 ? 'text-foreground-500' : 'text-foreground-500'
                }`}>
                  <span>{article.publishDate}</span>
                  <div className="flex items-center gap-3">
                    <span><i className="ri-eye-line mr-0.5"></i>{(article.viewCount / 10000).toFixed(1)}万</span>
                    <span><i className="ri-chat-3-line mr-0.5"></i>{article.commentCount}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}